var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGassStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.918,
    height: 15.31,
    viewBox: "0 0 13.918 15.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0410\\u0417\\u0421",
    transform: "translate(0 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_588",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 588",
    transform: "translate(0 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1658",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1658",
    d: "M31.406,0l-.678.783,2.627,2.3v7.272a.679.679,0,0,1-1.357,0V5.463A1.559,1.559,0,0,0,30.431,3.9h-.383V1.688A1.559,1.559,0,0,0,28.483.122H22.046A1.559,1.559,0,0,0,20.48,1.688V14.614a.7.7,0,0,0,.7.7h8.177a.7.7,0,0,0,.7-.7V4.941h.383a.513.513,0,0,1,.522.522v4.889a1.723,1.723,0,0,0,3.445,0V2.61ZM28.291,6.785H22.237V2.035h6.054Z",
    transform: "translate(-20.48)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGassStation);
export default __webpack_public_path__ + "static/media/GassStation.c0bdafefd63bbe523c2a2e66fddce5d9.svg";
export { ForwardRef as ReactComponent };